<template>
  <div>
    <doe-label v-if="label" :name="name" size="small">
      {{ label }}
    </doe-label>
    <span v-for="(option, index) in options" :class="option.value" :key="index">
      {{ option.text }}
    </span>
  </div>
</template>

<script>
import DoeLabel from "@/components/field/Label";

export default {
  name: "DoeTag",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    }
  },
  components: {
    DoeLabel
  }
};
</script>

<style lang="scss" scoped>
p {
  @apply block font-sans font-light text-base text-black leading-tight;
}
span {
  @apply inline-block font-sans font-semibold leading-tight p-1 mr-2 select-none text-center text-sm text-white;
}
.pdhpe {
  background: #048506;
}
.science {
  background: #30bc59;
}
.english {
  background: #5e88e8;
}
.creative-arts {
  background: #5e01da;
}
.mathematics {
  background: #de8700;
}
.hsie {
  background: #ea0204;
}
</style>
